export enum SocialProvider {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  PASSWORD = 'password',
  EMAIL = 'email'
}
